import { render, staticRenderFns } from "./OneVideoEdit.vue?vue&type=template&id=f3641158&scoped=true"
import script from "./OneVideoEdit.vue?vue&type=script&lang=js"
export * from "./OneVideoEdit.vue?vue&type=script&lang=js"
import style0 from "./OneVideoEdit.vue?vue&type=style&index=0&id=f3641158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3641158",
  null
  
)

export default component.exports